import * as AT from '../actions/_types.js'

const updateTask = (prevState = {}, action) => {
  switch (action.type) {
    case AT.TASK_MARK_INCOMPLETE:
    case AT.TASK_MARK_COMPLETE:
    case AT.TASK_MARK_DELETED: {
      // update status of an individual task
      return Object.assign({},
        prevState,
        { status: action.nextStatus },
      )
    }
    default: {
      return prevState
    }
  }
}

export default (prevState = {
  ids: [],
  byId: {},
  isLoaded: false,
  byStatus: { incomplete: [], complete: [], deleted: [] },
  numTasks: 0,
}, action) => {
  switch (action.type) {
    case AT.TASK_MARK_INCOMPLETE:
    case AT.TASK_MARK_COMPLETE:
    case AT.TASK_MARK_DELETED: {
      const { taskId } = action
      const updatedTask = updateTask(prevState.byId[taskId], action)
      const nextState = Object.assign({},
        prevState.byId,
        { [taskId]: updatedTask },
      )
      return {
        ...prevState,
        byId: nextState,
      }
    }
    case AT.TASKS_UPDATE_LISTS: {
      // update the list of task ids, grouped by their status
      const nextState = Object.assign({},
        prevState.byStatus,
        action.nextIdsByStatus,
      )
      return {
        ...prevState,
        byStatus: nextState,
      }
    }
    case AT.TASKS_PREPEND_TO_LIST: {
      const nextIdsByStatus = {}
      let prevList,
        nextList
      Object.getOwnPropertyNames(prevState.byStatus).forEach((status) => {
        prevList = prevState.byStatus[status]
        nextList = (action.payload[status] || [])
        nextIdsByStatus[status] = nextList.concat(prevList)
      })

      return {
        ...prevState,
        byStatus: nextIdsByStatus,
      }
    }
    case AT.TASKS_MERGE_TODAY: {
      return {
        ...prevState,
        byId: Object.assign({}, prevState.byId, action.byId),
        numTasks: prevState.numTasks + action.numTasks,
        ids: prevState.ids.concat(action.ids),
      }
    }
    case AT.TASKS_IS_FETCHING: {
      return {
        ...prevState,
        isFetching: action.value,
      }
    }
    case AT.TASKS_RECEIVE: {
      return {
        ...prevState,
        byId: action.byId,
        ids: action.ids,
        byStatus: Object.assign({}, prevState.byStatus, action.byStatus),
        numTasks: action.numTasks,
      }
    }
    default: {
      return prevState
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/tasks.js